module.exports = __webpack_public_path__ + "img/16.8be93354.png";